import React from 'react'
import PropTypes from 'prop-types'
import { StringCreator } from '@leverege/api-attributes'
import Util from './Util'

import { TextInput } from '~/views'

export default class StringEditor extends React.Component {

  static TYPE = StringCreator.typeName();

  static propTypes = {
    attribute : PropTypes.object,
    name : PropTypes.string,
    value : PropTypes.string,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.onChange = Util.onChange.bind( this )
  }

  shouldComponentUpdate( nextProps, nextState ) {
    return false
  }
  
  render() {
    const { attribute : attr, value, focus, changeOnReturn, alwaysFireOnReturn, changeOnBlur = false } = this.props
    if ( attr == null ) {
      return <div />
    }
 
    return (
      <div>
        <TextInput
          hint="Set value..." 
          value={value} 
          focus={focus}
          changeOnBlur={changeOnBlur}
          changeOnReturn={changeOnReturn}
          alwaysFireOnReturn={alwaysFireOnReturn}
          onChange={this.onChange} />
      </div>
    ) 
  }
}
